import { AudioPlayerSingleton } from '@ssml-editor/modules';
import { wrapper, markWrapper, icon, EditorUtils, markText } from '@ssml-editor/vue';

const soundEventRenderElement = ({
  element,
  children,
  attributes,
  editor
}) => {
  const node = element;
  return wrapper(
    attributes,
    markWrapper(
      [
        icon(
          null,
          ["iconfont-ssml-editor", "icon-ssml-editor-close-fill"],
          void 0,
          {
            onClick: (event) => {
              event.stopPropagation();
              AudioPlayerSingleton.stop().unload();
              EditorUtils.removeByNode(editor, node);
            }
          }
        ),
        icon(
          null,
          ["iconfont-ssml-editor", "icon-ssml-editor-bofang"],
          void 0,
          {
            onClick: (event) => {
              event.stopPropagation();
              AudioPlayerSingleton.play({ src: node.src });
            }
          }
        ),
        icon(
          null,
          ["iconfont-ssml-editor", "icon-ssml-editor-zanting"],
          void 0,
          {
            onClick: (event) => {
              event.stopPropagation();
              AudioPlayerSingleton.pause();
            }
          }
        )
      ],
      markText(node.mark),
      void 0,
      { "background-color": "var(--cosy-voice-sound-event)" }
    ),
    icon(children, ["iconfont-ssml-editor", "icon-ssml-editor-shengyin"], {
      color: "var(--cosy-voice-sound-event)"
    })
  );
};

export { soundEventRenderElement };
//# sourceMappingURL=render-element.js.map
